import { computed, toValue } from "vue";
import { useComponentTypes } from "src/shared/store/component-type/composables/useComponentTypes";
export const useSocketFilterType = (componentMutable) => {
    const { componentTypes } = useComponentTypes();
    const filterType = computed({
        get: () => {
            var _a;
            const mutable = toValue(componentMutable);
            return (_a = mutable === null || mutable === void 0 ? void 0 : mutable.getFilter().component_type) !== null && _a !== void 0 ? _a : "";
        },
        set: (value) => {
            const mutable = toValue(componentMutable);
            if (mutable) {
                mutable.setFilter({
                    component_type: value,
                });
            }
        },
    });
    const componentTypeOptions = computed(() => {
        return componentTypes.value
            .map((type) => ({
            displayName: `${type.getDisplayName()} (${type.type})`,
            value: type.type,
        }))
            .sort((a, b) => a.displayName.localeCompare(b.displayName));
    });
    return {
        filterType,
        componentTypeOptions,
    };
};
